import type { AcaoId } from '@acme/core'
import type { AcaoUi } from './acao-ui'
import { lancarAbono } from './lancar-abono'
import { lancarAfastamento } from './lancar-afastamento'
import { notificarEmail } from './notificar-email'
import { notificarSite } from './notificar-site'

/**
 * Registro único da tela das ações, uma por arquivo. Ação nova no catálogo do
 * `@acme/core` sem entrada aqui não compila.
 */
export const ACOES_UI = {
    'notificar-site': notificarSite,
    'notificar-email': notificarEmail,
    'lancar-afastamento': lancarAfastamento,
    'lancar-abono': lancarAbono,
} as const satisfies Record<AcaoId, AcaoUi>
